import { CommunityStats } from "../../actions/appExpandedActions/communities";

const initialState = {
  // Community data
  notices: { docs: [], totalPages: 0 },
  communityCalendar: { docs: [], totalPages: 0 },
  communityFiles: { docs: [], totalPages: 0 },
  communityServices: { docs: [], totalPages: 0 },
  communityMeetings: { docs: [], totalPages: 0 },
  communityWallets: { docs: [], totalPages: 0 },
  polls: { docs: [], totalPages: 0 },
  fundraisers: { docs: [], totalPages: 0 },
  
  // Community stats
  communityStats: {},
  aggregatedStats: {},

  // Add missing state properties
  communityChats: { docs: [], totalPages: 0 },
  communityTransactions: { docs: [], totalPages: 0 },
  communityBankAccounts: { docs: [], totalPages: 0 },
  communityFolders: { docs: [], totalPages: 0 },
  communityMembers: { docs: [], totalPages: 0 },
  communityAdministrators: { docs: [], totalPages: 0 },
  communityPrintOrders: { docs: [], totalPages: 0 },
  communityUtilityBills: { docs: [], totalPages: 0 },
  communityPolls: { docs: [], totalPages: 0 },
  communityFunds: { docs: [], totalPages: 0 },
  
  // Loading states
  loading: false,
};

const handleNewDocs = (state, payload, key) => {
  if (payload?.page === 1) return payload.docs;

  const existingDocs = state[key]?.docs || [];
  const newDocs = payload?.docs || [];

  const _docs = newDocs.filter(
    (newDoc) => !existingDocs.find((oldDoc) => newDoc._id === oldDoc._id)
  );

  return [...existingDocs, ..._docs];
};

const communities = (state = initialState, { type, payload } = {}) => {
  switch (type) {
    case CommunityStats.GET_COMMUNITY_AGGREGATED_STATS_SUCCESS:
      return {
        ...state,
        communityStats: payload,
        aggregatedStats: {
          ...state.aggregatedStats,
          // Community-only stats
          noticesCount: payload.notices?.notices || 0,
          usersCreatingNotices: payload.notices?.users || 0,
          communityEventsCount: payload.events?.events || 0,
          usersCreatingCommunityEvents: payload.events?.users || 0,
          communityMeetingsCount: payload.meetings?.meetings || 0,
          communityUsersCreatingMeetings: payload.meetings?.participants || 0,
          filesCount: payload.files?.files || 0,
          usersCreatingFiles: payload.files?.users || 0,
          communityWalletsCount: payload.wallets?.wallets || 0,
          communityServiceSearchesCount: payload.assistantQueries?.assistantQueries || 0,
          usersSearchingServices: payload.assistantQueries?.users || 0,
          pollsCount: payload.funds?.funds || 0,
          usersCreatingPolls: payload.funds?.users || 0,
          usersVoting: payload.funds?.users || 0,
        },
      };

    case CommunityStats.GET_NEIGHBORS_NOTICES_SUCCESS:
      return {
        ...state,
        notices: {
          ...state.notices,
          docs: handleNewDocs(state, payload, "notices"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_NEIGHBORS_CALENDAR_SUCCESS:
      return {
        ...state,
        communityCalendar: {
          ...state.communityCalendar,
          docs: handleNewDocs(state, payload, "communityCalendar"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_NEIGHBOURS_FILES_SUCCESS:
      return {
        ...state,
        communityFiles: {
          ...state.communityFiles,
          docs: handleNewDocs(state, payload, "communityFiles"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_NEIGHBORS_SERVICES_SUCCESS:
      return {
        ...state,
        communityServices: {
          ...state.communityServices,
          docs: handleNewDocs(state, payload, "communityServices"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_NEIGHBORS_MEETINGS:
      return {
        ...state,
        loading: true,
      };

    case CommunityStats.GET_NEIGHBORS_MEETINGS_SUCCESS:
      return {
        ...state,
        communityMeetings: {
          ...state.communityMeetings,
          docs: handleNewDocs(state, payload, "communityMeetings"),
          totalPages: payload.totalPages,
        },
        loading: false,
      };

    case CommunityStats.GET_NEIGHBORS_MEETINGS_ERROR:
      return {
        ...state,
        loading: false,
      };

    case CommunityStats.GET_NEIGHBORS_WALLETS_SUCCESS:
      return {
        ...state,
        communityWallets: {
          ...state.communityWallets,
          docs: handleNewDocs(state, payload, "communityWallets"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_NEIGHBORS_POLLS_SUCCESS:
      return {
        ...state,
        polls: {
          ...state.polls,
          docs: handleNewDocs(state, payload, "polls"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_NEIGHBORS_PAYMENTS_SUCCESS:
      return {
        ...state,
        fundraisers: {
          ...state.fundraisers,
          docs: handleNewDocs(state, payload, "fundraisers"),
          totalPages: payload.totalPages,
        },
      };

    // Add missing reducer cases
    case CommunityStats.GET_COMMUNITY_CHATS_SUCCESS:
      return {
        ...state,
        communityChats: {
          ...state.communityChats,
          docs: handleNewDocs(state, payload, "communityChats"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_COMMUNITY_TRANSACTIONS:
      return {
        ...state,
        loading: true,
      };

    case CommunityStats.GET_COMMUNITY_TRANSACTIONS_SUCCESS:
      return {
        ...state,
        communityTransactions: {
          ...state.communityTransactions,
          docs: handleNewDocs(state, payload, "communityTransactions"),
          totalPages: payload.totalPages,
        },
        loading: false,
      };

    case CommunityStats.GET_COMMUNITY_TRANSACTIONS_ERROR:
      return {
        ...state,
        loading: false,
      };

    case CommunityStats.GET_COMMUNITY_BANK_ACCOUNTS_SUCCESS:
      return {
        ...state,
        communityBankAccounts: {
          ...state.communityBankAccounts,
          docs: handleNewDocs(state, payload, "communityBankAccounts"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_COMMUNITY_FOLDERS_SUCCESS:
      return {
        ...state,
        communityFolders: {
          ...state.communityFolders,
          docs: handleNewDocs(state, payload, "communityFolders"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_COMMUNITY_MEMBERS_SUCCESS:
      return {
        ...state,
        communityMembers: {
          ...state.communityMembers,
          docs: handleNewDocs(state, payload, "communityMembers"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_COMMUNITY_ADMINISTRATORS_SUCCESS:
      return {
        ...state,
        communityAdministrators: {
          ...state.communityAdministrators,
          docs: handleNewDocs(state, payload, "communityAdministrators"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_COMMUNITY_PRINT_ORDERS_SUCCESS:
      return {
        ...state,
        communityPrintOrders: {
          ...state.communityPrintOrders,
          docs: handleNewDocs(state, payload, "communityPrintOrders"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_COMMUNITY_POLLS_SUCCESS:
      return {
        ...state,
        communityPolls: {
          ...state.communityPolls,
          docs: handleNewDocs(state, payload, "communityPolls"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_COMMUNITY_FUNDS_SUCCESS:
      return {
        ...state,
        communityFunds: {
          ...state.communityFunds,
          docs: handleNewDocs(state, payload, "communityFunds"),
          totalPages: payload.totalPages,
        },
      };

    case CommunityStats.GET_COMMUNITY_UTILITY_BILLS:
      return {
        ...state,
        communityUtilityBills: {
          ...state.communityUtilityBills,
          isLoading: true,
        },
      };

    case CommunityStats.GET_COMMUNITY_UTILITY_BILLS_SUCCESS:
      return {
        ...state,
        communityUtilityBills: {
          ...state.communityUtilityBills,
          docs: handleNewDocs(state, payload, "communityUtilityBills"),
          totalPages: payload.totalPages,
          isLoading: false,
        },
      };

    default:
      return state;
  }
};

export default communities;